<div *ngIf="user" class="section padding-top-bottom-120 profile-nfr rana-shell-flush" id="page-top">
    <div class="section-1400 rana-full-bleed">
        <div class="container-fluid px-0">
            <div class="row no-gutters rana-shell" id="accordionExample">
                <div class="col-lg-4 rana-shell-rail">
                    <div class="section border-4 p-3 p-xl-4 rana-nav-rail">
                        <div class="row">
                            <div class="col-sm-6 img-wrap">
                                <!--img class="border-4"  src="assets/img/profile/1.png" alt="" -->
                                <img class="border-4" [src]="
                    uploadedImageUrl || 'assets/img/profile/default-user.png'
                  " alt=""/>
                            </div>

                            <div class="col-12 mt-3">
                                <h5 class="mb-1"
                                    *ngIf="user && user.firstname">{{ user.firstname }} {{ user.lastname }}</h5>
                                <p class="mb-0 color-primary">{{ getMembershipLabel(userType) }}, {{userChapter}}</p>
                                <button *ngIf="user && !['MEMBER', 'LIFE_MEMBER', 'ANNUAL_MEMBER' ].includes(user.memberType)  && user.applicationStatus!='PAYMENT_COMPLETE'"
                                        class="btn btn-sm btn-primary mt-2"
                                        (click)="payNow()">Become Member
                                </button>

                            </div>
                            <div class="w-100 mt-4"></div>
                            <div class="col-auto">
                                <p class="mb-0 color-dark font-weight-500 size-16">Email:</p>
                            </div>
                            <div class="col text-right">
                                <p class="mb-0 size-16" *ngIf="user && user.email">{{ user.email }}</p>
                            </div>
                            <div class="w-100 mt-1"></div>
                            <div class="col-auto">
                                <p class="mb-0 color-dark font-weight-500 size-16">Phone:</p>
                            </div>
                            <div class="col text-right">
                                <p class="mb-0 size-16" *ngIf="user &&  user.phone">{{ user.phone }}</p>
                            </div>
                            <div class="w-100 mt-1"></div>
                            <div class="col-auto">
                                <p class="mb-0 color-dark font-weight-500 size-16">Location:</p>
                            </div>
                            <div class="col text-right">
                                <p class="mb-0 size-16" *ngIf="user">{{ user.city }}, {{ user.state }}</p>
                            </div>

                            <div class="w-100 mt-1"></div>
                            <div class="col-auto">
                                <p class="mb-0 color-dark font-weight-500 size-16">Membership:</p>
                            </div>
                            <div class="col text-right">
                                <p class="mb-0 size-16" *ngIf="user">{{ getMembershipLabel(user.memberType) }}</p>
                                <p class="mb-0 size-12 color-primary" *ngIf="user && user.memberType=='NON_MEMBER' && user.applicationStatus=='PAYMENT_COMPLETE'" >(Registration Paid)</p>

                            </div>

                            <div class="col-12 mt-4 d-lg-none">
                                <button type="button" class="rana-nav-mobile-toggle" data-toggle="collapse"
                                        data-target="#profileNavRailLinks" aria-expanded="false"
                                        aria-controls="profileNavRailLinks">
                                    <span>Menu</span>
                                    <i class="uil uil-angle-down size-20"></i>
                                </button>
                            </div>
                            <div class="col-12 mt-lg-4 collapse d-lg-block" id="profileNavRailLinks">
                                <a href="#page-top" data-gal="m_PageScroll2id"
                                   class="btn btn-user-profile btn-fluid justify-content-start" data-toggle="collapse"
                                   data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    <i class="uil uil-layers size-22 mr-2 pr-1"></i>
                                    Profile Overview
                                </a>
                                <a href="#page-top" data-gal="m_PageScroll2id"
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="uil uil-user-circle size-22 mr-2 pr-1"></i>
                                    Personal Info
                                </a>

                                <a href="#page-top" data-gal="m_PageScroll2id"
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                    <i class="uil uil-key-skeleton size-22 mr-2 pr-1"></i>
                                    Change Password
                                </a>
                                <a href="#page-top" data-gal="m_PageScroll2id"
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseUserCard" aria-expanded="false"
                                   aria-controls="collapseUserCard"
                                   (click)="openUserSearch()">
                                    <i class="uil uil-users-alt size-22 mr-2 pr-1"></i>
                                    Search Users
                                </a>
                                <a href="#page-top" data-gal="m_PageScroll2id"
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseBlogs" aria-expanded="false" aria-controls="collapseBlogs"
                                   (click)="openBlogs()">
                                    <i class="uil uil-edit size-22 mr-2 pr-1"></i>
                                    Blogs &amp; Poems
                                </a>
                                <a href="#page-top" data-gal="m_PageScroll2id"
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseBiz" aria-expanded="false" aria-controls="collapseBiz"
                                   (click)="openBiz()">
                                    <i class="uil uil-shop size-22 mr-2 pr-1"></i>
                                    Business Directory
                                </a>
                                <!--a href="#page-top" data-gal="m_PageScroll2id"
                                 class="btn btn-user-profile btn-fluid justify-content-start mt-1" data-toggle="collapse"
                                 data-target="#collapseMatrimonial" aria-expanded="false" aria-controls="collapseMatrimonial">
                                 <i class="uil uil-key-skeleton size-22 mr-2 pr-1"></i>
                                 Matrimonial
                               </a-->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 mt-4 mt-lg-0 rana-shell-main">

                    <div class="section border-4 p-3 p-xl-4 rana-shell-main-inner">


                        <!-- Chapter Notifications Section -->
                        <div *ngIf="chapterNotifications && chapterNotifications.length > 0" class="m-3">
                            <h5>🔔 Notifications</h5>
                            <ul class="list-group">
                                <li *ngFor="let notification of chapterNotifications"
                                    class="list-group-item d-flex justify-content-between align-items-center list-group-item-info">
                                    <div>
                                        <strong>{{ notification.message }}</strong>
                                        <br/>
                                        <small class="text-muted">{{ notification.addedDate | date:'medium' }}</small>
                                        <br>
                                        <a *ngIf="notification.targetURL" routerLink="{{ notification.targetURL }}">Click here for additional details</a>
                                    </div>
                                    <button class="btn btn-sm btn-info ms-2"
                                            (click)="dismissChapterNotification(notification.notificationId)">
                                        ✖ Dismiss
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <!-- User Notifications Section (existing) -->
                        <div *ngIf="userNotificationsToShow.length > 0" class="m-3">
                            <ul class="list-group">
                                <li
                                        *ngFor="let notification of userNotificationsToShow"
                                        class="list-group-item d-flex justify-content-between align-items-center"
                                        [ngClass]="{'list-group-item-info': notification.status === 'UNREAD'}">
                                    <div>
                                        <strong>{{ notification.message }}  </strong>
                                        <br/>
                                        <small class="text-muted">{{ notification.addedDate | date:'medium' }} — {{ notification.addedBy }}</small>
                                        <br>
                                        <a *ngIf="notification.targetURL" routerLink="{{ notification.targetURL }}">Click here for additional details</a>
                                    </div>
                                    <button
                                            class="btn btn-sm btn-info ms-2"
                                            (click)="markAsDeleted(notification.userNotificationId)">
                                        ✖ Remove 🔔
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div id="collapseOne" #collapseOne class="collapse p-0 show" data-parent="#accordionExample">
                            <div class="card-body p-0">
                                <h1 class="rana-page-title" style="font-size:22px;">Profile Overview</h1>

                                <div class="rana-info-row" *ngIf="user">
                                    <div class="rana-info-card" *ngIf="user.maritalStatus !== 'Single'">
                                        <div class="rana-info-icon">
                                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>
                                        </div>
                                        <div>
                                            <div class="rana-info-label">Spouse Name</div>
                                            <div class="rana-info-value">{{ user.spouseName || '—' }}</div>
                                        </div>
                                    </div>
                                    <div class="rana-info-card" *ngIf="user.maritalStatus !== 'Single'">
                                        <div class="rana-info-icon info">
                                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>
                                        </div>
                                        <div>
                                            <div class="rana-info-label">Spouse Email</div>
                                            <div class="rana-info-value">{{ user.spouseEmailId || '—' }}</div>
                                        </div>
                                    </div>
                                    <div class="rana-info-card">
                                        <div class="rana-info-icon success">
                                            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                                        </div>
                                        <div>
                                            <div class="rana-info-label">Member Since</div>
                                            <div class="rana-info-value">{{ user.createDate }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="mb-4" *ngIf="user?.kidDetails?.length">
                                    <h2 class="rana-panel-title" style="font-size:15px;">Kids Details</h2>
                                    <div class="rana-info-row">
                                        <div class="rana-kid-card" *ngFor="let kid of user.kidDetails">
                                            <div class="rana-avatar">{{ (kid.firstName || '?').charAt(0) }}{{ (kid.lastName || '').charAt(0) }}</div>
                                            <div>
                                                <div class="rana-info-value" style="font-size:14px;">{{ kid.firstName }} {{ kid.lastName }}</div>
                                                <div class="rana-info-label" style="margin-bottom:0;">Born {{ kid.yearOfBirth }}</div>
                                                <div class="small text-muted" *ngIf="kid.email">{{ kid.email }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="rana-panel" *ngIf="user && user.aboutMe">
                                    <div class="rana-panel-title">About</div>
                                    <app-rt-editor [disabled]="true" [ngModel]="user.aboutMe"></app-rt-editor>
                                </div>

                                <!-- Nudge to list a business -->
                                <div class="rana-panel mt-4 d-flex flex-wrap align-items-center justify-content-between" *ngIf="showBizPrompt">
                                    <div class="mr-3">
                                        <strong><i class="uil uil-shop"></i> Run a business? Put it on the RANA directory.</strong>
                                        <div class="size-13 text-muted">It takes about two minutes and lets members find, recommend and contact you.</div>
                                    </div>
                                    <div>
                                        <a class="btn btn-dark-primary mr-2" routerLink="/biz-directory/new">List my business</a>
                                        <button type="button" class="rana-action-btn" (click)="dismissBizPrompt()">Not now</button>
                                    </div>
                                </div>

                                <!-- Latest blogs posted by members -->
                                <div class="rana-panel mt-4">
                                    <app-blog-feed [compact]="true"></app-blog-feed>
                                </div>

                                <div class="row">
                                    <div class="col-12 py-3">
                                        <div class="section divider one-dashed"></div>
                                    </div>
                                    <!--div class="col-12">
                                      <h6 class="mb-3">Recent posts</h6>
                                    </div>
                                    <div class="col-md-6">
                                      <div class="section blog-wrap-4 small">
                                        <div class="row">
                                          <div class="col-auto align-self-center">
                                            <a routerLink="/blog" class="link-heading animsition-link">
                                            </a>
                                          </div>
                                          <div class="col align-self-center">
                                            <p class="mb-1 size-16">Sep 10, 2019</p>
                                            <h6 class="mb-0">
                                              <a routerLink="/blog" class="link-heading animsition-link">Rajputs across the world</a>
                                            </h6>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-md-6 mt-4 mt-md-0">
                                      <div class="section blog-wrap-4 small">
                                        <div class="row">
                                          <div class="col-auto align-self-center">
                                            <a routerLink="/blog" class="link-heading animsition-link">
                                            </a>
                                          </div>
                                          <div class="col align-self-center">
                                            <p class="mb-1 size-16">Sep 08, 2019</p>
                                            <h6 class="mb-0">
                                              <a routerLink="/blog" class="link-heading animsition-link">History of Rajput warriors</a>
                                            </h6>
                                          </div>
                                        </div>
                                      </div>
                                    </div -->
                                </div>
                            </div>
                        </div>


                        <div id="collapseUserCard" class="collapse p-0" data-parent="#accordionExample">
                            <app-user-card *ngIf="showUserSearch"></app-user-card>
                        </div>

                        <div id="collapseBlogs" #collapseBlogs class="collapse p-0" data-parent="#accordionExample">
                            <div class="m-3" *ngIf="showBlogs" [ngSwitch]="routedView">
                                <app-blog *ngSwitchCase="'post'"></app-blog>
                                <app-blog-editor *ngSwitchCase="'edit'"></app-blog-editor>
                                <app-user-card *ngSwitchCase="'member'" [initialSelectedUserId]="memberId"></app-user-card>
                                <app-blog-feed *ngSwitchDefault></app-blog-feed>
                            </div>
                        </div>

                        <div id="collapseBiz" #collapseBiz class="collapse p-0" data-parent="#accordionExample">
                            <div class="m-3" *ngIf="showBiz" [ngSwitch]="routedView">
                                <app-biz-detail *ngSwitchCase="'bizDetail'"></app-biz-detail>
                                <app-biz-form *ngSwitchCase="'bizForm'"></app-biz-form>
                                <app-biz-opportunities *ngSwitchCase="'bizOpps'"></app-biz-opportunities>
                                <app-biz-start-up *ngSwitchCase="'bizStart'"></app-biz-start-up>
                                <app-biz-directory *ngSwitchDefault></app-biz-directory>
                            </div>
                        </div>

                        <div id="collapseMatrimonial" class="collapse p-0" data-parent="#accordionExample">
                            <app-matrimonial></app-matrimonial>
                        </div>


                        <div id="collapseTwo" class="collapse p-0" data-parent="#accordionExample">
                            <div class="card-body p-0">
                                <div class="row">
                                    <div class="col-12">
                                        <h5 class="mb-1">Personal Info</h5>
                                        <p class="mb-3">Update your personal informaiton.</p>
                                    </div>
                                    <form [formGroup]="profileForm" class="section nfr-form-standard">
                                        <div class="col-12 pb-4">
                                            <div class="section divider divider-gray"></div>
                                        </div>


                                        <div class="col-md-9 align-self-center">
                                            <p class="mb-9 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                Change your Profile Picture:
                                            </p>
                                        </div>
                                        <div class="col-9 col-sm-5 col-md-4 col-xl-3">
                                            <div class="section z-bigger">
                                                <div class="form-group choose-file avatar">
                                                    <input type="file" class="form-file"
                                                           (change)="onFileSelect($event)"/>
                                                    <label class="color-white">Choose File or Drag File Here</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> First Name:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div *ngIf="
                          firstname?.invalid &&
                          (firstname?.dirty || firstname?.touched)
                        ">
                                                <small class="font-weight-500" *ngIf="firstname?.errors?.['required']">First
                                                    Name is
                                                    required.</small>
                                            </div>
                                            <div class="form-group">
                                                <input type="text" [(ngModel)]="profileData.firstname"
                                                       name="profileData.firstname"
                                                       formControlName="firstname"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-user"></i>
                                            </div>
                                        </div>
                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Last Name:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div *ngIf="
                          lastname?.invalid &&
                          (lastname?.dirty || lastname?.touched)
                        ">
                                                <small class="font-weight-500" *ngIf="lastname?.errors?.['required']">Last
                                                    Name is
                                                    required.</small>
                                            </div>
                                            <div class="form-group">
                                                <input type="text" [(ngModel)]="profileData.lastname"
                                                       name="profileData.lastname"
                                                       formControlName="lastname"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-user-square"></i>
                                            </div>
                                        </div>
                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Company Name:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <input type="text" [(ngModel)]="profileData.companyName"
                                                       name="profileData.companyName"
                                                       formControlName="companyName"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-building"></i>
                                            </div>
                                        </div>
                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Contact Phone:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div *ngIf="
                          phone?.invalid && (phone?.dirty || phone?.touched)
                        ">
                                                <small class="font-weight-500" *ngIf="phone?.errors?.['required']">Phone
                                                    Number is
                                                    required.</small>
                                            </div>
                                            <div class="form-group">
                                                <input [(ngModel)]="profileData.phone" name="profileData.phone"
                                                       formControlName="phone"
                                                       type="tel"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-phone"></i>
                                            </div>
                                        </div>
                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Email Address:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div *ngIf="
                          email?.invalid && (email?.dirty || email?.touched)
                        ">
                                                <small class="font-weight-500" *ngIf="email ?.errors?.['required']">Email
                                                    is required.</small>
                                            </div>
                                            <div class="form-group">
                                                <input type="email" [(ngModel)]="profileData.email"
                                                       name="profileData.email"
                                                       formControlName="email"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-at"></i>
                                            </div>
                                        </div>


                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Address Line 1:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div *ngIf="
                      addressLine1?.invalid &&
                      (addressLine1?.dirty || addressLine1?.touched)
                    ">
                                                <small class="font-weight-500"
                                                       *ngIf="addressLine1?.errors?.['required']">Address Line 1 is
                                                    required.</small>
                                            </div>
                                            <div class="form-group">
                                                <input [(ngModel)]="profileData.addressLine1"
                                                       name="profileData.addressLine1"
                                                       formControlName="addressLine1" type="text"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-building"></i>
                                            </div>
                                        </div>


                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                Address Line 2:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                                <input [(ngModel)]="profileData.addressLine2"
                                                       name="profileData.addressLine2" formControlName="addressLine2"
                                                       type="text"
                                                       class="form-style big with-border form-style-with-icon" value=""
                                                       autocomplete="off"/>
                                                <i class="input-icon big uil uil-building"></i>
                                            </div>

                                        </div>


                                        <div class="w-100 pt-4"></div>

                                        <div class="row">
                                            <div class="col-md-3 align-self-center ml-3">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    <small>*</small> City:
                                                </p>
                                                <div *ngIf="
                            city?.invalid && (city?.dirty || city?.touched)
                          ">
                                                    <small class="font-weight-500" *ngIf="city?.errors?.['required']">City
                                                        is required.</small>
                                                </div>
                                                <div class="form-group">
                                                    <input [(ngModel)]="profileData.city" name="profileData.city"
                                                           formControlName="city"
                                                           type="text"
                                                           class="form-style big with-border form-style-with-icon"
                                                           value=""
                                                           autocomplete="off"/>
                                                    <i class="input-icon big uil uil-building"></i>
                                                </div>
                                            </div>

                                            <div class="col-md-3">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    <small>*</small> State:
                                                </p>
                                                <div *ngIf="
                            state?.invalid && (state?.dirty || state?.touched)
                          ">
                                                    <small class="font-weight-500" *ngIf="state?.errors?.['required']">State
                                                        is required.</small>
                                                </div>
                                                <div class="form-group">
                                                    <input [(ngModel)]="profileData.state" name="profileData.state"
                                                           formControlName="state"
                                                           type="text"
                                                           class="form-style big with-border form-style-with-icon"
                                                           value=""
                                                           autocomplete="off"/>
                                                    <i class="input-icon big uil uil-building"></i>
                                                </div>
                                            </div>

                                            <div class="col-md-3">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    <small>*</small> Zip Code:
                                                </p>
                                                <div *ngIf="
                            zipCode?.invalid &&
                            (zipCode?.dirty || zipCode?.touched)
                          ">
                                                    <small class="font-weight-500"
                                                           *ngIf="zipCode?.errors?.['required']">Zip Code is
                                                        required.</small>
                                                </div>
                                                <div class="form-group">
                                                    <input [(ngModel)]="profileData.zipCode" name="profileData.zipCode"
                                                           formControlName="zipCode"
                                                           type="text"
                                                           class="form-style big with-border form-style-with-icon"
                                                           value=""
                                                           autocomplete="off"/>
                                                    <i class="input-icon big uil uil-building"></i>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="w-100 pt-4"></div>
                                        <div class="row">
                                            <div class="col-md-3 ml-3">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">

                                                    <small>*</small> Country:
                                                </p>
                                                <div *ngIf="
                          country?.invalid &&
                          (country?.dirty || country?.touched)
                        ">
                                                    <small class="font-weight-500"
                                                           *ngIf="country?.errors?.['required']">Country is
                                                        required.</small>
                                                </div>
                                                <div class="form-group">
                                                    <input [(ngModel)]="profileData.country" name="profileData.country"
                                                           formControlName="country"
                                                           type="text"
                                                           class="form-style big with-border form-style-with-icon"
                                                           value=""
                                                           autocomplete="off"/>
                                                    <i class="input-icon big uil uil-building"></i>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="w-100 pt-4"></div>
                                        <div class="row">
                                            <div class="col-md-4 align-self-center ml-3">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    <small>*</small> Sub Caste:
                                                </p>
                                                <div *ngIf="
                        userSubCast?.invalid &&
                        (userSubCast?.dirty || userSubCast?.touched)
                      ">
                                                    <small class="font-weight-500"
                                                           *ngIf="userSubCast?.errors?.['required']">Sub Caste is
                                                        required.</small>
                                                </div>
                                                <div class="form-group">
                                                    <input [(ngModel)]="profileData.userSubCast"
                                                           name="profileData.userSubCast"
                                                           formControlName="userSubCast" type="text"
                                                           class="form-style big with-border form-style-with-icon"
                                                           value="" autocomplete="off"/>
                                                    <i class="input-icon big uil uil-building"></i>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    <small>*</small> Gotra:
                                                </p>
                                                <div *ngIf="
                          userGotra?.invalid && (userGotra?.dirty || userGotra?.touched)
                          ">
                                                    <small class="font-weight-500"
                                                           *ngIf="userGotra?.errors?.['required']">Gotra is
                                                        required.</small>
                                                </div>
                                                <div class="form-group">
                                                    <input [(ngModel)]="profileData.userGotra"
                                                           name="profileData.userGotra"
                                                           formControlName="userGotra" type="text"
                                                           class="form-style big with-border form-style-with-icon"
                                                           value="" autocomplete="off"/>
                                                    <i class="input-icon big uil uil-building"></i>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="w-100 pt-4"></div>
                                        <div class="row">
                                            <div class="col-md-4 align-self-center ml-3">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    <small>*</small> Chapter Affiliation:
                                                </p>
                                                <div
                                                        *ngIf="chapterAffiliation?.invalid && (chapterAffiliation?.dirty || chapterAffiliation?.touched)">
                                                    <small class="font-weight-500"
                                                           *ngIf="chapterAffiliation?.errors?.['required']">Please
                                                        select a
                                                        valid chapter Affiliation</small>
                                                </div>

                                                <div class="form-group">
                                                    <div class="section select-big with-border Select">
                                                        <select class="nice-select wide select-style"
                                                                id="profileData.chapterAffiliation"
                                                                [(ngModel)]="profileData.chapterAffiliation"
                                                                name="profileData.chapterAffiliation"
                                                                formControlName="chapterAffiliation">
                                                            <option value="">Select Option</option>
                                                            <option *ngFor="let item of chapterList; let i = index"
                                                                    value="{{ item.id }}">{{
                                                                    item.name
                                                                }}
                                                            </option>
                                                            <option value="NEC">I am not sure!</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="col-md-2 align-self-center">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    <small>*</small> Sex:
                                                </p>
                                                <div *ngIf="sex?.invalid && (sex?.dirty || sex?.touched)">
                                                    <small class="font-weight-500" *ngIf="sex?.errors?.['required']">Please
                                                        select a valid sex
                                                        type</small>
                                                </div>

                                                <div class="form-group">
                                                    <div class="section select-big with-border Select">
                                                        <select class="nice-select wide select-style"
                                                                id="profileData.sex" [(ngModel)]="profileData.sex"
                                                                name="profileData.sex" formControlName="sex">
                                                            <option value="">Select Option</option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="col-md-3">
                                                <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    <small>*</small> Marital Status:
                                                </p>
                                                <div *ngIf="
                            maritalStatus?.invalid &&
                            (maritalStatus?.dirty || maritalStatus?.touched)
                          ">
                                                    <small class="font-weight-500"
                                                           *ngIf="maritalStatus?.errors?.['required']">Marital Status is
                                                        required.</small>
                                                </div>
                                                <div class="form-group">
                                                    <div class="section select-big with-border Select">
                                                        <select class="nice-select wide select-style"
                                                                id="profileData.maritalStatus"
                                                                [(ngModel)]="profileData.maritalStatus"
                                                                name="profileData.maritalStatus"
                                                                formControlName="maritalStatus">
                                                            <option value="">Select Option</option>
                                                            <option value="Single">Single</option>
                                                            <option value="Married">Married</option>
                                                            <option value="Divorced">Divorced</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="profileData.maritalStatus=='Married' || profileData.maritalStatus=='Divorced'">
                                            <div *ngIf="profileData.maritalStatus=='Married'">
                                                <div class="w-100 pt-4"></div>
                                                <div class="col-md-3 align-self-center">
                                                    <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                        Spouse Name:
                                                    </p>
                                                </div>
                                                <div class="col-md-9">
                                                    <div class="form-group">
                                                        <input type="text" [(ngModel)]="profileData.spouseName"
                                                               name="profileData.spouseName"
                                                               formControlName="spouseName"
                                                               class="form-style big with-border form-style-with-icon"
                                                               value=""
                                                               autocomplete="off"/>
                                                        <i class="input-icon big uil uil-user"></i>
                                                    </div>
                                                </div>


                                                <div class="w-100 pt-4"></div>
                                                <div class="col-md-3 align-self-center">
                                                    <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                        Spouse Email id:
                                                    </p>
                                                </div>
                                                <div class="col-md-9">
                                                    <div class="form-group">
                                                        <input type="text" [(ngModel)]="profileData.spouseEmailId"
                                                               name="profileData.spouseEmailId"
                                                               formControlName="spouseEmailId"
                                                               class="form-style big with-border form-style-with-icon"
                                                               value="" autocomplete="off"/>
                                                        <i class="input-icon big uil uil-user"></i>
                                                    </div>
                                                </div>

                                                <div class="w-100 pt-4"></div>
                                                <div class="col-md-3 align-self-center">
                                                    <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                        Spouse Phone Number:
                                                    </p>
                                                </div>
                                                <div class="col-md-9">
                                                    <div class="form-group">
                                                        <input type="text" [(ngModel)]="profileData.spousePhoneNumber"
                                                               name="profileData.spousePhoneNumber"
                                                               formControlName="spousePhoneNumber"
                                                               class="form-style big with-border form-style-with-icon"
                                                               value="" autocomplete="off"/>
                                                        <i class="input-icon big uil uil-user"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <!--div class="w-100 pt-4"></div>
                                            <div class="col-md-6 align-self-center">
                                                <p class="mb-6 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                    Kids Name(s):
                                                </p>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <input type="text" [(ngModel)]="profileData.kidsName"
                                                           name="profileData.kidsName"
                                                           formControlName="kidsName"
                                                           class="form-style big with-border form-style-with-icon"
                                                           value=""
                                                           autocomplete="off"/>
                                                    <i class="input-icon big uil uil-user"></i>
                                                </div>
                                            </div-->

                                            <div class="w-100 pt-4"></div>
                                            <div class="col-12 pb-4">
                                                <div class="section divider divider-gray"></div>
                                            </div>

                                            <div class="col-12">
                                                <h5 class="mb-3">🧑‍🧒 Kid Details</h5>
                                            </div>

                                            <div formArrayName="kidDetails" class="col-12">
                                                <div *ngFor="let kidGroup of kidDetails.controls; let i = index" [formGroupName]="i" class="row border rounded p-3 mb-3">

                                                    <div class="col-md-4 mb-3">
                                                        <p class="mb-1 text-left color-gray-dark font-weight-500 size-16">
                                                            <small>*</small> First Name:
                                                        </p>
                                                        <div *ngIf="kidGroup.get('firstName')?.invalid && (kidGroup.get('firstName')?.dirty || kidGroup.get('firstName')?.touched)">
                                                            <small class="font-weight-500 text-danger" *ngIf="kidGroup.get('firstName')?.errors?.['required']">First Name is required.</small>
                                                        </div>
                                                        <div class="form-group mb-0">
                                                            <input type="text" formControlName="firstName" class="form-style big with-border" placeholder="First Name" autocomplete="off"/>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-4 mb-3">
                                                        <p class="mb-1 text-left color-gray-dark font-weight-500 size-16">
                                                            <small>*</small> Last Name:
                                                        </p>
                                                        <div *ngIf="kidGroup.get('lastName')?.invalid && (kidGroup.get('lastName')?.dirty || kidGroup.get('lastName')?.touched)">
                                                            <small class="font-weight-500 text-danger" *ngIf="kidGroup.get('lastName')?.errors?.['required']">Last Name is required.</small>
                                                        </div>
                                                        <div class="form-group mb-0">
                                                            <input type="text" formControlName="lastName" class="form-style big with-border" placeholder="Last Name" autocomplete="off"/>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-4 mb-3">
                                                        <p class="mb-1 text-left color-gray-dark font-weight-500 size-16">
                                                            Year of Birth (YYYY):
                                                        </p>
                                                        <div class="form-group mb-0">
                                                            <input type="text" formControlName="yearOfBirth" class="form-style big with-border" placeholder="e.g., 2010" pattern="\d{4}" autocomplete="off"/>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6 mb-3 mb-md-0">
                                                        <p class="mb-1 text-left color-gray-dark font-weight-500 size-16">
                                                            Email:
                                                        </p>
                                                        <div class="form-group mb-0">
                                                            <input type="email" formControlName="email" class="form-style big with-border" placeholder="Email Address" autocomplete="off"/>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-4 mb-3 mb-md-0">
                                                        <p class="mb-1 text-left color-gray-dark font-weight-500 size-16">
                                                            <small>*</small> Sex:
                                                        </p>
                                                        <div *ngIf="kidGroup.get('sex')?.invalid && (kidGroup.get('sex')?.dirty || kidGroup.get('sex')?.touched)">
                                                            <small class="font-weight-500 text-danger" *ngIf="kidGroup.get('sex')?.errors?.['required']">Sex is required.</small>
                                                        </div>
                                                        <div class="form-group mb-0">
                                                            <select formControlName="sex" class="form-style big with-border">
                                                                <option value="" disabled>Select Gender</option>
                                                                <option value="Male">Male</option>
                                                                <option value="Female">Female</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 align-self-end">
                                                        <button type="button" class="btn btn-sm btn-danger btn-fluid" (click)="removeKid(i)">
                                                            Remove
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-12 mt-3">
                                                <button type="button" class="btn btn-primary" (click)="addKid()">
                                                    <i class="uil uil-plus mr-1"></i> Add Another Kid
                                                </button>
                                            </div>

                                            <div class="w-100 pt-4"></div>
                                            <div class="col-12 pb-4">
                                                <div class="section divider divider-gray"></div>
                                            </div>


                                        </div>


                                        <div class="w-100 pt-4"></div>

                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> About Me:
                                            </p>
                                        </div>
                                        <div class="col-md-9">

                                            <div class="form-group" *ngIf="profileData?.aboutMe">


                                                <app-rt-editor formControlName="aboutMe" [(ngModel)]="profileData.aboutMe" name="profileData.aboutMe"></app-rt-editor>
                                            </div>
                                        </div>

                                        <div class="col-12 pt-5 pb-3">
                                            <div class="section divider one-dashed"></div>
                                        </div>
                                        <div class="offset-md-3 col-md-9">
                                            <a href="javascript:" (click)="updateProfile()"
                                               class="btn btn-primary mt-1 mr-2">Submit</a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div id="collapseFour" #collapseFour class="collapse p-0" data-parent="#accordionExample">
                            <div class="card-body p-0">
                                <div class="row">
                                    <div class="col-12">
                                        <h5 class="mb-1">Change Password</h5>
                                        <p class="mb-3 color-danger font-weight-500" *ngIf="user.resetPassword">
                                            Please Change your password after password reset.
                                        </p>
                                        <p class="mb-3 color" *ngIf="!user.resetPassword">
                                            Change your account password.
                                        </p>
                                    </div>
                                    <div class="col-12">
                                        <div class="section divider divider-gray"></div>
                                    </div>

                                    <!--div *ngIf="isPasswordUpdated" class="col-12">
                                      <div
                                        class="mt-4 alert alert-info alert-dismissible fade show text-center-v w-100"
                                        role="alert"
                                      >
                                        <i class="uil uil-exclamation-triangle size-18 mr-3"></i
                                        >Your Password is updated successfully!
                                        <button
                                          type="button"
                                          class="close"
                                          (click)="togglePasswordUpdated()"
                                          data-dismiss="alert"
                                          aria-label="Close"
                                        >
                                          <i class="uil uil-multiply size-20"></i>
                                        </button>
                                      </div>
                                    </div -->

                                    <form [formGroup]="passwordForm" class="section nfr-form-standard">
                                        <div class="w-100 pt-4"></div>
                                        <div *ngIf="passwordForm.errors?.['passwordMismatch'] && passwordForm.touched">
                                            <small class="px-3 font-weight-500">Passwords do not match!</small>
                                        </div>
                                        <div *ngIf="password?.touched && password?.errors?.['minlength']"
                                             class="text-danger">
                                            <small class="px-3 font-weight-500">Password must be at least 6 characters
                                                long.</small>
                                        </div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> New Password:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div *ngIf="
                          password?.invalid &&
                          (password?.dirty || password?.touched)
                        ">
                                                <small class="font-weight-500" *ngIf="password?.errors?.['required']">Password
                                                    is
                                                    required.</small>
                                            </div>

                                            <div class="form-group">
                                                <input [(ngModel)]="passwordData.password" name="passwordData.password"
                                                       formControlName="password" type="password"
                                                       class="form-style big with-border"
                                                       autocomplete="off"/>
                                            </div>
                                        </div>
                                        <div class="w-100 pt-4"></div>
                                        <div class="col-md-3 align-self-center">
                                            <p class="mb-3 mb-md-0 text-left text-md-left color-gray-dark font-weight-500 size-16">
                                                <small>*</small> Verify Password:
                                            </p>
                                        </div>
                                        <div class="col-md-9">
                                            <div *ngIf="
                          verifypassword?.invalid &&
                          (verifypassword?.dirty || verifypassword?.touched)
                        ">
                                                <small class="font-weight-500"
                                                       *ngIf="verifypassword?.errors?.['required']">Verify Password is
                                                    required.</small>
                                            </div>
                                            <div class="form-group">
                                                <input formControlName="verifypassword" type="password"
                                                       class="form-style big with-border"
                                                       autocomplete="off"/>
                                            </div>
                                        </div>

                                        <div class="col-12 pt-5 pb-3">
                                            <div class="section divider one-dashed"></div>
                                        </div>
                                        <div class="offset-md-3 col-md-9">
                                            <a href="javascript:" (click)="updatePassword()"
                                               class="btn btn-primary mt-1 mr-2">Change
                                                password</a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
